import React, {FC} from 'react';
import {Airfield} from "../../models/Airfield";
import ArrowRight from "../../icons/ArrowRight";
import {Link as RouterLink} from "react-router-dom";
import verifiedShield from '../../images/verified_Shield.png';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';

import {
    Box,
    Button,
    Card,
    Container,
    Grid,
    Skeleton,
    Stack,
    Table,
    TableBody,
    Tooltip,
    Typography,
} from '@material-ui/core';
import {useTranslation} from "react-i18next";
import {PaginationResult} from "../../types/paginationResult";
import TableRowsLoaderVariant from '../../components/TableRowsLoaderVariant';


interface image {
    albumId: number
    id: number,
    title: string,
    url: string,
    thumbnailUrl: string
}

interface AirfieldsPublicListProps {
    airfields: PaginationResult<Airfield>;
    recordLimit: number;
    isLoading: boolean
}

const AirfieldsPublicList: FC<AirfieldsPublicListProps> = (props) => {
    const { airfields, recordLimit, isLoading } = props;
    //From AirfieldList.tsx
    const { t } = useTranslation();



    return (

        <Container maxWidth={false} >

            <Box sx={{ mt: 1, mb: 1 }}>

                <Box sx={{ minWidth: 700 }}>
                    <Table>
                        <TableBody>{
                            isLoading ?
                                (<><TableRowsLoaderVariant rowsNum={recordLimit} height={250} hasDivider={false} />
                                </>) :
                                (
                                    <>
                                        {airfields?.items.map((airfield) => (
                                            <>

                                                <Card sx={{ mt: 2, display: 'flex' }} style={{ maxHeight: '250px' }}>
                                                    <div
                                                        style={{
                                                            overflow: 'hidden',
                                                            width: "50%",
                                                            height: 'calc(75vw / 4 * 3)', // 4:3 aspect ratio
                                                            maxHeight: '250px'
                                                        }}
                                                    >

                                                        {(airfield.firstPhotoUrl == undefined) &&
                                                            (<Skeleton animation="wave" variant="rectangular" width={400} height={355} />
                                                            )}

                                                        {!(airfield.firstPhotoUrl == undefined || airfield.firstPhotoUrl == "" || airfield.firstPhotoUrl == null) ?
                                                            <>
                                                                <img
                                                                    loading="lazy"
                                                                    src={airfield.firstPhotoUrl}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />

                                                            </> :
                                                            <Box sx={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                                                                <Typography sx={{ ml: 2, mt: 11, fontSize: 40 }}>
                                                                    {airfield.icaoCode == null ? "ICAO_404" : airfield.icaoCode}</Typography>
                                                                <NoPhotographyIcon sx={{ mt: 10 }} />
                                                            </Box>

                                                        }

                                                    </div>

                                                    <Grid container columns={10} spacing={2} sx={{ ml: 4 }}>

                                                        <Grid container columns={10}>
                                                            <Grid item xs={10}>

                                                                <Box sx={{ ml: 3, mt: 5 }}> </Box>
                                                                <Box sx={{ ml: 2, mt: 3 }}>
                                                                    <h1>{airfield.name}</h1>

                                                                </Box>
                                                            </Grid>

                                                            <Grid container spacing={3}>

                                                                <Grid item xs={6}>
                                                                    <Typography sx={{ ml: 2 }} color="textPrimary" variant="body1">ICAO: {airfield.icaoCode}</Typography>
                                                                    <Typography sx={{ mt: 2, ml: 2 }} color="textPrimary" variant="body1">{t("MUNICIPALITY_SHORT")}: {airfield.municipality}</Typography>
                                                                </Grid>
                                                                <Grid item xs={4} >
                                                                    <Typography sx={{ mb: 2 }} color="textPrimary" variant="body1">Prov:  {airfield.province}</Typography>
                                                                    <Typography sx={{ mt: 2 }} color="textPrimary" variant="body1">Reg:  {airfield.region}</Typography>
                                                                </Grid>
                                                            </Grid>

                                                        </Grid>


                                                    </Grid>



                                                    <Stack
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                        spacing={4}
                                                    >
                                                        {airfield.isRegistred &&
                                                            <Box sx={{ mt: -5, mr: 2, mb: 4 }}
                                                                component="img"
                                                                src={verifiedShield}
                                                                height={40}
                                                            />
                                                        }
                                                        <Tooltip title={t('DETAILS') || ''} aria-label={t('DETAILS') || ''}>
                                                            <Button sx={{ height: 40, color: "white", mt: airfield.isRegistred ? 0 : 7 }}
                                                                component={RouterLink}
                                                                to={`details?airfieldId=${airfield.id}`}>
                                                                <ArrowRight fontSize='large' />
                                                            </Button >
                                                        </Tooltip>
                                                        <Box sx={{ mt: 10 }}></Box>
                                                    </Stack>

                                                </Card>
                                            </>

                                        )
                                        )
                                        }
                                    </>
                                    //}
                                )
                        }
                        </TableBody>
                    </Table>
                </Box>

            </Box>
        </Container>
    );

};
export default AirfieldsPublicList;
